import React, { useEffect, useState } from "react";
import "./footer.min.css"
import { Link, NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { auth_service } from "../../authService";
import { isWebView, redirectToAppNewsepickPage } from "../../../utils/Common";
import { getMediaCoverageMenu } from "../../services/MediaCoverageApi";

function Footer(props) {
    const [loginSuccess] = useState(auth_service.isAuthenticated());
    const [userData] = useState(auth_service.getUserDetails());
    const [mediaCoverageFlag, setMediaCoverageFlag] = useState(false);

    const openNav = () => {
        //document.getElementById("amySidenav").style.width = "100%";
        document.body.classList.add('activeFilter');
    };

    const openMyAccountPanel = () => {
        document.body.classList.add('activeMyAccountPanelProf');
    };

    const openFooter = () => {
        document.body.classList.add('activeFooter');
    };
    const closeFooter = () => {
        document.body.classList.remove('activeFooter');
    };

    const getMediaCoverageMenuData = async () => {
        let response = await getMediaCoverageMenu();
        if(response?.message === "Success!") {
            setMediaCoverageFlag(response?.body);
        }
    }

    useEffect(() => {
        getMediaCoverageMenuData();
    }, [])

    return (<>
        <footer className="m-0">
            <button className="btn ftArrowBtn up" onClick={() => openFooter()}><i className="iUp-Angle-Arrow_Bold" /></button>
            <button className="btn ftArrowBtn down" onClick={() => closeFooter()}><i className="iDown-Angle-Arrow_Bold" /></button>

            <section className="footer-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 ftAbout text-center text-lg-start mb-3">
                            <figure>
                                <Link to="/">
                                    <img src={"https://cdn.newsepick.com/logoBrand-r.png"} alt="Newsepick" className="img-fluid ft-logo" />
                                </Link>
                            </figure>
                            <p>
                                Newsepick aims to provide simplified solutions for students 
                                in grades 3 to 12. Students embark on a transformative learning 
                                journey that fosters deep engagement with current 
                                affairs and their curriculum learning.
                            </p>
                            <ul className="social">
                                <li>
                                    <Link to={"https://www.facebook.com/newsepick"} target="_blank" aria-label="Visit on Facebook">
                                        <i className="fa-brands fa-facebook-f" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://twitter.com/newsepick"} target="_blank" aria-label="Visit on Twitter">
                                        <i className="fa-brands fa-x-twitter" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://www.instagram.com/newsepick/"} target="_blank" aria-label="Visit on Instagram">
                                        <i className="fa-brands fa-instagram" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://www.linkedin.com/company/newsepick/about/"} target="_blank" aria-label="Visit on Linkedin">
                                        <i className="fa-brands fa-linkedin-in" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://youtube.com/@newsepick"} target="_blank" aria-label="Visit on Youtube">
                                        <i className="fa-brands fa-youtube" />
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-6 col-md-8 ps-xl-5 mb-3 pt-2 linkWidget">                            
                            <div className="row">
                                <div className="col-8 col-sm-8 useLinkCol">
                                    <h4>Useful Links</h4>
                                    <div className="row">
                                        <div className="col-6 col-sm-6">
                                            <ul className="quick-links">
                                                <li><Link to="/company/about-us">About Us</Link></li>
                                                <li><Link to="/company/why-us">Why Us</Link></li>
                                                {/* <li><Link to="/media-kit">Media kit</Link></li> */}
                                                {mediaCoverageFlag && <li><Link to="/media">Media coverage</Link></li>}
                                            </ul>
                                        </div>
                                        <div className="col-6 col-sm-6">
                                            <ul className="quick-links">
                                                {/* <li><Link to="/help-center/how-to-use">How to Use</Link></li> */}
                                                <li><Link to="/help-center/faq">Faq</Link></li>
                                                <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("trending")}>Trending</a></li>
                                                <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("latest")}>Latest</a></li>
                                            </ul>
                                        </div>                                        
                                    </div>                                    
                                </div>
                                <div className="col-4 col-sm-4 productLinkCol">
                                    <h4>Products</h4>
                                    <ul className="quick-links">
                                        <li><Link to={"/solutions/develop"}>Develop</Link></li>
                                        <li><Link to={"/solutions/evolve"}>Evolve</Link></li>
                                        <li><Link to={"/solutions/reuse"}>Reuse</Link></li>
                                        <li><Link to={"/solutions/voice"}>Voice</Link></li>
                                        <li><Link to={"/solutions/collab"}>Collab</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>                      

                        <div className="col-lg-3 col-md-4 mb-3 pt-2 contactWidget">
                            <h4>Contact Us</h4>
                            <div className="widget-contact">
                                <p className="footer-info">
                                    <i className="fas fa-map-marker-alt"></i> 35A & 35B, The Legacy, <br />25A, Shakespeare Sarani Rd, Park Street area, Kolkata 700017
                                </p>
                                <p className="footer-info">
                                    <i className="fa-solid fa-phone"></i> <a href="tel:+919903999574" className="text-inherit">+91 9903999574</a>
                                </p>
                                <p className="footer-info">
                                    <i className="fas fa-envelope"></i>
                                    <a className="text-inherit" href="mailto:support@newsepick.com" target="_blank">support@newsepick.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="copyright">
                <div className="container">
                    <div className="appDwnlBtns">
                        <figure>
                            <Link to={"https://apps.apple.com/us/app/newsepick/id6473382773"} target="_blank" aria-label="Download on the App Store">
                                <LazyLoadImage
                                    effect="blur"
                                    src={"https://cdn.newsepick.com/apple-btn.png"}
                                    //onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.newsepick.com/apple-btn.png"}}
                                    className="img-fluid" alt="Download on the App Store" />
                            </Link>
                        </figure>
                        <figure>
                            <Link to={"https://play.google.com/store/apps/details?id=com.wse.newsepick"} target="_blank" aria-label="Get it on Google Play">
                                <LazyLoadImage
                                    effect="blur"
                                    src={"https://cdn.newsepick.com/googleplay-btn.png"}
                                    //onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.newsepick.com/googleplay-btn.png"}}
                                    className="img-fluid" alt="Get it on Google Play" />
                            </Link>
                        </figure>
                    </div>
                    <p>
                        All Rights Reserved,{" "}  © <a href="https://wseinfratech.com/" target="_blank">
                            WSE Infratech
                        </a>{" "} 2024{" "}
                        |&nbsp;
                        <Link to="/terms-condition">Terms and Conditions</Link>&nbsp;|&nbsp;
                        <Link to="/privacy-policy">Privacy Policy</Link>
                    </p>
                </div>
            </section>
        </footer>

        {/* {!isWebView() && 
            <section className="mobile-spl-nav">
                <div className="container">
                    <ul>
                        <li> <a href="javascript:void(0)" onClick={() => openNav()}> <i className="iFilters_Fill" /> <p>Filters</p> </a> </li>
                        <li> <NavLink to="/" exact activeClassName="active"> <i className="iHome_Fill" /> <p>Home</p> </NavLink> </li>
                        {!loginSuccess ?
                            <li> <a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("login")} target="_blank"> <i className="iAccount_Fill" /> <p>Account</p> </a> </li> :
                            <li> <a href="javascript:void(0)" onClick={() => { openMyAccountPanel(); }}> <i className="iAccount_Fill" /> <p>Account</p> </a> </li>
                        }
                    </ul>
                </div>
            </section>
        } */}

        {props.pageType != "SUMMER_VAC" &&
            <a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("quiz")} className="btn btnQuiz">
                <figure>
                    <i className="iView" />
                </figure>
                <div>VIEW QUIZ <span>ARTICLES</span></div>
            </a>
        }
    </>
    );
}

export { Footer };
